"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLocationTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
exports.ServiceLocationTransport = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    address: common_1.AddressTransport,
    coordinates: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Object({
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }))),
    county: typebox_1.Type.Optional(typebox_1.Type.String()),
    hidden: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
//# sourceMappingURL=service-location-transport.js.map